export const GET_PRODUCT_QUESTION_LIST="GET_PRODUCT_QUESTION_LIST"
export const CLEAR_PRODUCT_QUESTION_LIST="CLEAR_PRODUCT_QUESTION_LIST"